export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_04.122596e3.jpg";